module.exports = {
  'account.footer.copyright': '© 2018 - 2019 Binance.org. All rights reserved.',
  'account.footer.copyright.trubi': '© 2018 - 2019 Trubi. All rights reserved.',
  'account.footer.exchange': 'Exchange',
  'account.footer.home': 'Home',
  'balances.filteredByAsset': 'Filtered by asset',
  'balances.hideZeroBalance': 'Hide Zero Balance',
  'balances.myBalances': 'My Balances',
  'blocked.country.list':
    "United States of America, Albania, Bosnia and Herzegovina, Belarus, Congo (DRC), Côte d'Ivoire, Crimea, Cuba, Iraq, Iran, North Korea, Liberia, Macedonia, Myanmar, Serbia, Sudan, Syria, Zimbabwe.",
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.confirm': 'Confirm ',
  'common.connect': 'Connect',
  'common.continue': 'Continue',
  'common.errorOccured': 'error occured',
  'common.goBack': 'Go Back',
  'common.googleUnlock': 'Google Drive',
  'common.keystoreFile': 'Keystore File',
  'common.ledgerDevice': 'Ledger Device',
  'common.loading': 'Loading',
  'common.mnemonicPhrase': 'Recovery Phrase',
  'common.networkError': 'Network Error',
  'common.or': 'or',
  'common.password': 'Password',
  'common.placeOrder': 'Place Order',
  'common.pleaseCheckVisitWebsite': 'Please check that you are visiting ',
  'common.previous': 'Previous',
  'common.privateKey': 'Private Key',
  'common.systemError': 'System Error',
  'common.trezorDevice': 'Trezor Device',
  'common.viewMyPrivateKey': 'View my Private Key',
  'common.viewOnly': 'View Only',
  'common.walletConnect': 'Mobile Wallet',
  'common.yes': 'Yes',
  'common.warning': 'Warning',
  'create.backupKeystore.backupYour': 'Backup your ',
  'create.backupKeystore.cannotRecoveredIt': 'It cannot be recovered if you lose it.',
  'create.backupKeystore.createBackupFile': 'Create a backup of this file!',
  'create.backupKeystore.downloadKeystoreFile': 'Download Keystore File (UTC/JSON)',
  'create.backupKeystore.getMyPrivateKey': 'Get my Private Key',
  'create.backupKeystore.keystoreFile': 'Keystore File',
  'create.backupKeystore.needFirstDownload': 'You have to download keystore file first',
  'create.backupKeystore.notShareFile':
    'Do not share or use this file on any unverified websites. Your funds can potentially be stolen.',
  'create.backupMnemonic.note':
    'Back up the text below on paper and keep it somewhere secret and safe.',
  'create.backupMnemonic.title': 'Please backup mnemonic',
  'create.backupText': 'Back up the text below on paper and keep it somewhere secret and safe.',
  'create.chooseKSOrMnemonic.keystoreAndPassword': 'Keystore File + Password',
  'create.chooseKSOrMnemonic.keystoreFile': 'Keystore File',
  'create.chooseKSOrMnemonic.recommendedUSBDrive': 'Recommended to be backed up on a USB drive',
  'create.chooseKSOrMnemonic.recommendedUSBDriveOrPaper':
    'Recommended to be backed up on paper or on a USB drive',
  'create.chooseKSOrMnemonic.title': 'How do you want to create your new wallet?',
  'create.chooseKSOrMnemonic.unlockExistWallet': 'Unlock an Existing Wallet',
  'create.chooseKSOrMnemonic.useKeystoreFile':
    'Use your Keystore File (UTC / JSON) + Password to access your wallet',
  'create.chooseKSOrMnemonic.useMnemonicPhrase':
    'Use your 24-word Mnemonic Phrase to access your wallet',
  'create.confirmNote': 'Are you sure you have noted down your Mnemonic Phrase?',
  'create.createNewWallet': 'Create New Wallet',
  'create.doubleConfirmMnemonic.note':
    'Please select the Mnemonic Phrase in the correct order to ensure that your copy is correct.',
  'create.doubleConfirmMnemonic.title': 'Choose Secondary Access',
  'create.doubleConfirmMnemonic.tryAgain': 'Incorrect Mnemonic Phrase order. Please try again.',
  'create.downloadKeyStoreFile': 'Download Keystore File',
  'create.enterPassword': 'Enter a Password',
  'create.google.createWallet': 'Create wallet',
  'create.google.createdSuccessfully': 'Wallet Created Successfully',
  'create.google.creationFailure': 'Wallet Creation Failure',
  'create.google.tryAgain': 'Try again',
  'create.google.walletName': 'Wallet name',
  'create.googledrive.rePassErr': 'The password entered does not match',
  'create.keystoreFileAndPassword': 'Create Keystore File + Password',
  'create.pick.useGoogleDrive.description': 'Create a new wallet using your Google account',
  'create.pick.useGoogleDrive.title': 'Using Google Drive',
  'create.pick.useLocalKeystore.description':
    'Create a new wallet that you can store on your device',
  'create.pick.useLocalKeystore.title': 'Using Keystore File',
  'create.pleaseCheck': 'Please check that you are visiting ',
  'create.reEnterPassword': 'Re-enter Password',
  'create.stepTwo.desc':
    'We are about to show your mnemonic phrase, please ensure that no one else is looking at your screen.',
  'create.success.desc1': 'You are ready to use the Binance Chain Wallet and',
  'create.success.desc2': 'Decentralized Exchange!',
  'create.success.title': "You're all set!",
  'create.success.unlockWallet': 'Unlock the wallet',
  'create.tutorial.next': 'Next',
  'create.tutorial.skip': 'Skip Tutorial (Not Recommended)',
  'create.tutorial.step1.desc1':
    'Binance is committed to providing you with the best and safest experience on the Binance Chain. To do that, we ask for a minute of your time to understand how decentralized wallets work and to take action in safeguarding yourself. You can find the full Terms of Service here.',
  'create.tutorial.step1.title': 'Our Commitment',
  'create.tutorial.step2.desc1':
    'You are solely responsible for keeping your funds. No one else, not even Binance, can help you recover your wallet if you lose it.',
  'create.tutorial.step2.desc2':
    'When you create a wallet on Binance, you are provided with 3 different formats, each of them can be used to access your wallet.',
  'create.tutorial.step2.title': 'Keeping Your Funds',
  'create.tutorial.step3.desc1':
    'You can think of the keystore file like a “User ID”, while the password unlocks your wallet. Both are needed to access your wallet,so keep them safe. This is a required format on Binance.',
  'create.tutorial.step3.title': 'Keystore File + Password',
  'create.tutorial.step4.desc1':
    '24 words that are both the “User ID” and password.This is a secondary way to access your wallet if you lose your keystore file or forget your password. Anyone who knows your mnemonic phrase can access your wallet, so keep it safe.',
  'create.tutorial.step4.title': 'Mnemonic Phrase',
  'create.tutorial.step5.desc1':
    'This is an alternative representation of the mnemonic phase words.',
  'create.tutorial.step5.desc2':
    'Binance requires all users to use the keystore file + password; and choose between the mnemonic phrase or private key as a secondary method.',
  'create.tutorial.step5.title': 'Private key',
  'create.tutorial.title': 'Wallet Creation Tutorial',
  'create.tutorial.understand': 'I Understand',
  'create.understandCheckbox':
    'I understand that Binance cannot recover or reset my password or the keystore file. I will make a backup of the keystore file/password, keep them secret, complete all wallet creation steps and agree to all the ',
  'create.understandCheckbox.terms': 'terms',
  'create.unlockExistWallet': 'Unlock an Existing Wallet',
  'create.yourKeyStore': 'Your Keystore',
  'editWallet.remove': 'Remove',
  'editWallet.remove.desc1': 'Please check that the wallet has no money',
  'editWallet.remove.desc2': 'as there is no way of recovering the wallet',
  'editWallet.remove.removeButton': 'Yes, remove this wallet',
  'editWallet.remove.title': 'Do you really want to remove this wallet?',
  'editWallet.rename': 'Rename',
  'editWallet.rename.duplicateName': 'Wallet name is exist',
  'editWallet.rename.errMsg': 'Name should not be null',
  'editWallet.rename.title': 'Wallet name',
  'editWallet.title': 'Wallet Name',
  'editWallet.createWallet': 'Create Wallet',
  'editWallet.unlockWallet': 'Unlock Wallet',
  'exchange.BTCValue': 'BTC Value',
  'exchange.amount': 'Amount',
  'exchange.asset': 'Asset',
  'exchange.availableBalance': 'Available Balance',
  'exchange.blockHeight': 'BlockHeight',
  'exchange.buy': 'Buy',
  'exchange.calendar.clear': 'Clear',
  'exchange.calendar.ok': 'Ok',
  'exchange.calendar.today': 'Today',
  'exchange.chartbox.depth': 'Depth',
  'exchange.coin': 'Coin',
  'exchange.date': 'Date',
  'exchange.estimatedValue': 'Estimated Value',
  'exchange.filled': 'Filled',
  'exchange.from': 'From',
  'exchange.frozen': 'Frozen',
  'exchange.hideAllCanceled': 'Hide all canceled',
  'exchange.hideOtherPairs': 'Hide Other Pairs',
  'exchange.inOrder': 'In Order',
  'exchange.index.books': 'Books',
  'exchange.index.chart': 'Chart',
  'exchange.max': 'Max',
  'exchange.min': 'Minimum trading unit:',
  'exchange.name': 'Name',
  'exchange.notional': 'Notional',
  'exchange.oneDay': '1 Day',
  'exchange.oneMonth': '1 Month',
  'exchange.oneWeek': '1 Week',
  'exchange.pair': 'Pair',
  'exchange.placeOrder.bestAsk': 'Best Ask',
  'exchange.placeOrder.bestBid': 'Best Bid',
  'exchange.placeOrder.limitOrder': 'Limit Order',
  'exchange.placeOrder.noEnoughBalance': 'not enough balance',
  'exchange.placeOrder.orderError': 'Order Error',
  'exchange.placeOrder.orderPriceHigher':
    'Your order price will be 2% higher than the latest market price. Please proceed cautiously.',
  'exchange.placeOrder.orderPriceLow':
    'Your order price will be 2% less than the latest market price. Please proceed cautiously.',
  'exchange.placeOrder.pleaseInputCorrectAmount': 'please input correct amount',
  'exchange.placeOrder.pleaseInputCorrectPrice': 'please input correct price',
  'exchange.placeOrder.roundSizeErrorMsg':
    'You can only {side} {baseAsset} in multiples of {lotSize}',
  'exchange.placeOrder.successNotifyMsg':
    'You have successfully created a limit order to {side} {quantity} {quoteAsset}',
  'exchange.placeOrder.successNotifyTitle': 'Limit {side} Order Created',
  'exchange.pleaseSelectDate': 'please select date',
  'exchange.pleaseUnlockWallet.btn': 'Unlock Wallet',
  'exchange.pleaseUnlockWallet.createNewWallet': 'Create New Wallet',
  'exchange.pleaseUnlockWallet.desc': 'Oops! Please unlock your wallet first',
  'exchange.pleaseUnlockWallet.noWallet': 'No Wallet?',
  'exchange.price': 'Price',
  'exchange.search': 'Search',
  'exchange.sell': 'Sell',
  'exchange.side': 'Side',
  'exchange.status': 'Status',
  'exchange.symbolPriceInfo.high': 'High',
  'exchange.symbolPriceInfo.lastPrice': 'Last Price',
  'exchange.symbolPriceInfo.low': 'Low',
  'exchange.symbolPriceInfo.twentyFourHChange': '24h Change',
  'exchange.symbolPriceInfo.twentyFourHHigh': '24h High',
  'exchange.symbolPriceInfo.twentyFourHLow': '24h Low',
  'exchange.symbolPriceInfo.twentyFourHVolume': '24h Volume',
  'exchange.symbolPriceInfo.vol': 'Vol',
  'exchange.threeMonths': '3 Months',
  'exchange.time.from': 'From',
  'exchange.to': 'To',
  'exchange.total': 'Total',
  'exchange.totalBalance': 'Total Balance',
  'exchange.tradingHistory.time': 'Time',
  'exchange.tradingHistory.title': 'Trading History',
  'exchange.tradingPair.change': 'Change',
  'exchange.tradingPair.pair': 'Pair',
  'exchange.tradingPair.price': 'Price',
  'exchange.tradingPair.search': 'Search',
  'exchange.tradingPair.volume': 'Volume',
  'exchange.txFee': 'TxFee',
  'exchange.txHash': 'TxHash',
  'exchange.type': 'Type',
  'exchange.value': 'Value',
  'fees.fee': 'Fee',
  'fees.height': 'Height',
  'fees.note': 'Note',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy',
  'googledrive.create.nameExist': 'Name exist',
  'header.balances': 'Balances',
  'header.createWallet': 'Create Wallet',
  'header.exchange': 'Exchange',
  'header.explorer': 'Explorer',
  'header.faq': 'Docs / FAQ',
  'header.feeHistory': 'Fee History',
  'header.forums': 'Forums',
  'header.mainnet': 'Mainnet',
  'header.openOrders': 'Open Orders',
  'header.orderHistory': 'Order History',
  'header.orders': 'Orders',
  'header.testnet': 'testnet',
  'header.tradeHistory': 'Trade History',
  'header.transactions': 'Transactions',
  'header.unlockWallet': 'Unlock Wallet',
  'header.user.changeWallet': 'Change Wallet',
  'header.user.closeWallet': 'Close Wallet',
  'header.user.coinomi': 'Coinomi ',
  'header.user.copyAddress': 'copy address',
  'header.user.copySuccess': 'Copy successful!',
  'header.user.createNewWallet': 'Create New Wallet',
  'header.user.exportKeystoreFile': 'Export Keystore File',
  'header.user.goToExplorer': 'go to explorer',
  'header.user.infinito': 'Infinito ',
  'header.user.ledger': 'Ledger ',
  'header.user.trezor': 'Trezor Device',
  'header.user.wallet': 'Wallet',
  'header.user.walletConnect': 'WalletConnect ',
  'header.youWantCloseWallet': 'Are you sure you want to close wallet?',
  'home.aboutPage.desc1.line1': 'Binance Chain is a blockchain initially developed by Binance.',
  'home.aboutPage.desc1.line2':
    "It's modern, safe and has near-instant transaction finality (it's fast).",
  'home.aboutPage.desc2.line1': 'Binance DEX is a decentralized order matching engine,',
  'home.aboutPage.desc2.line2': 'powered by the core Binance Chain technology.',
  'home.aboutPage.desc3.line1': 'Binance DEX is a modern and secure marketplace for issuing',
  'home.aboutPage.desc3.line2':
    'and exchanging digital assets, and no-one other than you holds your keys. Trading your favorite assets has never been safer.',
  'home.aboutPage.title': 'About Binance DEX',
  'home.binanceDex': 'Binance DEX',
  'home.processPage.aboutBalance': 'About Binance DEX',
  'home.processPage.create': 'Create',
  'home.processPage.createDesc': 'First step is to create a Binance Chain address.',
  'home.processPage.createWallet': 'Create a New Wallet',
  'home.processPage.getStart': 'Get started with Binance DEX',
  'home.processPage.go': 'Go',
  'home.processPage.placeOrders': 'Place Orders',
  'home.processPage.placeOrdersDesc': 'Use the web wallet or API to send and cancel orders.',
  'home.processPage.transferAssets': 'Transfer Assets',
  'home.processPage.transferAssetsDesc':
    'With a Binance Chain address, which can be generated with any wallet that supports Binance Chain, you can transfer BNB or other assets stored on that address.',
  'home.processPage.unlock': 'Unlock',
  'home.processPage.unlockDesc': 'Four ways to unlock your wallet',
  'home.processPage.unlockMode1': 'WalletConnect',
  'home.processPage.unlockMode2': 'Ledger',
  'home.processPage.unlockMode3': 'Keystore File + Password',
  'home.processPage.unlockMode4': 'Mnemonic',
  'home.processPage.unlockWallet': 'Unlock a Wallet',
  'home.startPage.createWallet': 'Create a Wallet',
  'home.startPage.desc1': 'Fast and secure decentralized digital asset exchange',
  'home.startPage.desc2': 'The new cryptocurrency trading standard is here.',
  'home.startPage.getTestBNB': 'Get Test BNB',
  'home.startPage.startTrading': 'Start Trading',
  'home.whyPage.community': "It's a Community Initiative",
  'home.whyPage.communityDesc':
    'Binance DEX is powered by on-chain governance and open source software components.',
  'home.whyPage.decentralized': 'Decentralized',
  'home.whyPage.decentralizedDesc':
    'Experience direct wallet to wallet trading without any third party or central authority.',
  'home.whyPage.getStarted': 'Get Started',
  'home.whyPage.lowTradingFees': 'Low Trading Fees',
  'home.whyPage.lowTradingFeesDesc':
    'Trade with no withdrawal, deposit, or order placement fees — and BNB holders benefit even more.',
  'home.whyPage.safeAndSecure': 'Safe and Secure',
  'home.whyPage.safeAndSecureDesc':
    'Your funds are stored on a blockchain address with a private key that only you control.',
  'home.whyPage.title': 'Why Binance DEX',
  'home.whyPage.userFriendly': 'User Friendly',
  'home.whyPage.userFriendlyDesc':
    "Create a wallet, unlock your wallet, and you're ready to trade. No need to deposit or withdraw.",
  'inputPassword.passwordRule': 'Your password must include the following properties',
  'inputPassword.passwordRule1': '8 or more characters',
  'inputPassword.passwordRule2': 'An upper-case letter, symbol and a number',
  'inputPassword.setANewPassword': 'Set a New Password',
  'landing.connectWallet': 'Connect Wallet',
  'landing.createWallet': 'Create Wallet',
  'landing.desc1': 'Binance DEX',
  'landing.desc2':
    'Fast and secure decentralized digital asset exchange. The new crypto currency trading standard is here.',
  'landing.footer.fee': 'Fee',
  'landing.footer.terms': 'Term of Service',
  'landing.footer.privacy': 'Privacy',
  'landing.how.connect': 'Connect',
  'landing.how.connect.desc':
    'Accessing Binance DEX is easier than you think. Click the connect button and choose from connection options. You’re all set.',
  'landing.how.create': 'Create',
  'landing.how.create.desc':
    'Binance DEX gives you the freedom to choose from convenient keystores to ultra-secure hardware wallet options.',
  'landing.how.step': 'step',
  'landing.how.title': 'How to use',
  'landing.how.trade': 'Trade',
  'landing.how.trade.desc':
    'Our goal is to make trading seamless and indistinguishable from Binance.com. To do that, we have optimised the best features so that everything you love is on Binance DEX too.',
  'landing.markets': 'Markets',
  'landing.markets.24HChange': '24H Change',
  'landing.markets.24HVolume': '24H Volume',
  'landing.markets.lastPrice': 'Last Price',
  'landing.markets.pair': 'Pair',
  'landing.markets.searchPlaceholder': 'Search coin name',
  'landing.menu.balances': 'Balances',
  'landing.menu.changeWallet': 'Change Wallet',
  'landing.menu.closeWallet': 'Close Wallet',
  'landing.menu.community': 'Community',
  'landing.menu.copyAddress': 'copy address',
  'landing.menu.docs': 'Docs',
  'landing.menu.exchange': 'Exchange',
  'landing.menu.explorer': 'Explorer',
  'landing.menu.orders': 'Orders',
  'landing.menu.orders.feeHistory': 'Fee History',
  'landing.menu.orders.openOrders': 'Open Orders',
  'landing.menu.orders.orderHistory': 'Order history',
  'landing.menu.orders.tradeHistory': 'Trade History',
  'landing.menu.testnet': 'Testnet',
  'landing.menu.tools': 'Tools',
  'landing.menu.transaction': 'Transaction',
  'landing.menu.wallet': 'Wallet',
  'landing.startTrading': 'Start Trading',
  'landing.trust.activeAddress': 'Active Wallets',
  'landing.trust.activeAddress.desc':
    "More people trust Binance DEX's infrastructure and trading systems than any other wallet solution.",
  'landing.trust.pairs': 'Pairs',
  'landing.trust.pairs.desc':
    'Binance DEX gives you more options and the flexibility to trade, with more added every week.',
  'landing.trust.rank': 'Ranked',
  'landing.trust.rank.desc':
    'Binance DEX is the #1 decentralized cryptocurrency exchange on Coinmarketcap by volume.',
  'landing.trust.title': 'Why people trust us',
  'landing.why.competitive': 'Competitive',
  'landing.why.competitive.desc':
    'Fees are just 0.04% when you use BNB to pay for trading fees. That’s almost half of Binance.com, the world’s leading exchange on trading fees.',
  'landing.why.fast': 'Fast',
  'landing.why.fast.desc':
    'With 1 second block times, blockchain trade confirmations are a thing of the past. Get all the advantages of a DEX without the downsides.',
  'landing.why.secure': 'Secure',
  'landing.why.secure.desc':
    'Binance DEX takes security to a whole new level. Peer-to-peer transfers and trades mean virtually zero exposure to security threats.',
  'landing.why.title': 'Why Binance DEX',
  'lang.menu.copyAddress': ' ',
  'noContent.descPrefix': 'You have no ',
  'openOrders.areYourTrue': 'Are you sure you want to',
  'openOrders.cancel': 'cancel',
  'openOrders.cancel all': 'cancel all',
  'openOrders.cancel buy': 'cancel buy',
  'openOrders.cancel sell': 'cancel sell',
  'openOrders.cancelAll': 'Cancel All',
  'openOrders.cancelBuy': 'Cancel Buy',
  'openOrders.cancelOrder': 'Cancel Order',
  'openOrders.cancelOrders': 'Cancel Orders',
  'openOrders.cancelPartialSuccess': 'Cancel partial success',
  'openOrders.cancelSell': 'Cancel Sell',
  'openOrders.cancelSuccess': 'Cancel Success',
  'openOrders.keepOrder': 'Keep Order',
  'openOrders.keepOrders': 'Keep Orders',
  'openOrders.noBuyOpenOrders': 'no buy open orders',
  'openOrders.noOpenOrders': 'no open orders',
  'openOrders.noSellOpenOrders': 'no sell open orders',
  'openOrders.title': 'Open Orders',
  'orderForm.amount': 'Amount',
  'orderForm.avb': 'Avb',
  'orderForm.buy': 'Buy',
  'orderForm.equivalent': 'Equivalent',
  'orderForm.price': 'Price',
  'orderForm.sell': 'Sell',
  'orderForm.total': 'Total',
  'orderHistory.openHistory': 'order history',
  'orderHistory.title': 'Order History',
  'orderHistory.tradeId': 'Trade ID',
  'orderHistory.tradingPrice': 'Trade Price',
  'orderHistory.tradingTotal': 'Trading Total',
  'privateKeyModal.backupText':
    'Back up the text below on paper and keep it somewhere secret and safe.',
  'privateKeyModal.title': 'Your Private Key',
  'testnet.binanceChainExplorerGuide': 'Binance Chain Explorer Guide',
  'testnet.fastAndSecureDesc': 'Fast and secure decentralized digital asset exchange',
  'testnet.fundingYourTestnetAccount': 'Funding Your Testnet Account',
  'testnet.howToAccessYourWallet': 'How to Access Your Wallet',
  'testnet.howToCreateAWallet': 'How to Create a Wallet',
  'testnet.interfaceGuide': 'Interface Guide',
  'testnet.thingsToAvoid': 'Things to Avoid',
  'testnet.title': 'Binance Decentralized Exchange (TESTNET)',
  'token.issueModal.mintable': 'Mintable',
  'token.issueModal.name': 'Token Name',
  'token.issueModal.nameErrMsg': 'token name is limited to 32 characters',
  'token.issueModal.symbol': 'Symbol',
  'token.issueModal.symbolErrMsg': 'symbol should be alphanumeric and length is limited to 3~8',
  'token.issueModal.title': 'Issue Token',
  'token.issueModal.totalSupply': 'Total Supply',
  'token.issueModal.totalSupplyErrMsg': 'invalid supply amount',
  'token.listModal.address': 'Address',
  'token.listModal.confirm': 'Confirm',
  'token.listModal.initPrice': 'Init Price',
  'token.listModal.proposalId': 'ProposalId',
  'token.listModal.quoteAsset': 'Quote Asset',
  'token.listModal.title': 'List Token',
  'token.listModal.tokenName': 'Token Name',
  'token.main.burn': 'Burn',
  'token.main.freeze': 'Freeze',
  'token.main.issueToken': 'Issue Token',
  'token.main.list': 'List',
  'token.main.listSuccessmsg': 'List success',
  'token.main.mint': 'Mint',
  'token.main.proposal': 'Proposal',
  'token.main.submitListFirst': 'Please submit list proposal first',
  'token.main.submitSuccessmsg': 'submit list proposal success',
  'token.main.title': 'My Token List',
  'token.main.unfreeze': 'UnFreeze',
  'token.proposalModal.address': 'Address',
  'token.proposalModal.baseAsset': 'Base Asset',
  'token.proposalModal.desc': 'Description',
  'token.proposalModal.expireTime': 'Expire Time',
  'token.proposalModal.hours': 'Hours',
  'token.proposalModal.initDeposit': 'Initial Deposit',
  'token.proposalModal.initPrice': 'Init Price',
  'token.proposalModal.initPriceErr': 'Init price should not be null',
  'token.proposalModal.initPriceErr2': 'init price should greater than 0',
  'token.proposalModal.quoteAsset': 'Quote Asset',
  'token.proposalModal.title': 'List Proposal',
  'token.proposalModal.titleErr': 'Proposal title should not be null',
  'token.proposalModal.titleErr2': 'Proposal title is longer than max length of 128',
  'token.proposalModal.votingPeriod': 'Voting Period',
  'token.table.col.mintable': 'Mintable',
  'token.table.col.name': 'Name',
  'token.table.col.symbol': 'Symbol',
  'token.table.col.totalSupply': 'Total Supply',
  'token.tokenModal.address': 'Address',
  'token.tokenModal.amount': 'Amount',
  'token.tokenModal.available': 'Available',
  'token.tokenModal.burnTitle': 'Burn Token',
  'token.tokenModal.confirm': 'Confirm',
  'token.tokenModal.desc': ' ',
  'token.tokenModal.freezeTitle': 'Freeze Token',
  'token.tokenModal.mintTitle': 'Mint Token',
  'token.tokenModal.name': 'Name',
  'token.tokenModal.unfreezeTitle': 'Unfreeze Token',
  'token.warning':
    'We do not support walletconnect compatible wallets currently and for security reason, Ledger is the best choice to Issue/List/Mint/Burn Token',
  'tradeHistory.tradeHistory': 'trade history',
  'transaction.here': 'here',
  'transaction.notes': 'Not every transaction is included below. For full history, please refer to',
  'txHistory.here': 'here',
  'txHistory.notEveryTransactionIsIncludedBelow':
    'Not every transaction is included below. For full history, please refer to here.',
  'txHistory.title': 'Transaction History',
  'unlock.connectAddress.enterYourAddress': 'Enter your address',
  'unlock.connectAddress.invalidAddress': 'Invalid address',
  'unlock.connectAddress.viewOnlyMode': 'Enter an address for view only mode',
  'unlock.createNewWallet': 'Create a New Wallet',
  'unlock.google.chooseWallet': 'Choose from your available wallets:',
  'unlock.google.logIn': 'Log in',
  'unlock.google.notLoggedIn': 'You have not logged into your Google Account',
  'unlock.google.signedInAs': 'You are signed in as',
  'unlock.googledrive.editWallet': 'Edit Wallet Details',
  'unlock.googledrive.wallets': 'Select from your following wallets to continue:',
  'unlock.index.selectUnlockType': 'Select how you would like to unlock',
  'unlock.index.title': 'Unlock Your Wallet',
  'unlock.keystore.enterYourWalletPass': 'Enter your wallet password',
  'unlock.keystore.paste': 'Or paste the contents of your keystore file',
  'unlock.keystore.select': 'Connect an encrypted wallet file and input your password',
  'unlock.keystore.upload': 'Upload keystore file',
  'unlock.ledger.appInstallation': 'App Installation',
  'unlock.ledger.binanceChainReady': 'Binance Chain Ready',
  'unlock.ledger.connectToLedger': 'Connect to Ledger',
  'unlock.ledger.enterPINCode': 'Enter PIN Code',
  'unlock.ledger.getTheApp': 'Get the app',
  'unlock.ledger.havingConnectionIssues': 'Having Connection Issues?',
  'unlock.ledger.mustBeOnScreen': 'must be on-screen',
  'unlock.ledger.openBinanceChain': 'Open Binance Chain',
  'unlock.ledger.text': 'Connect your hardware wallet here by following the on-screen instructions',
  'unlock.ledger.title': 'Unlock with a Ledger Device',
  'unlock.ledger.usageInstructions': 'Usage Instructions',
  'unlock.mnemonic.pleaseEnterYourPhrase': 'Please enter your 24 word phrase',
  'unlock.mnemonic.pleaseSeparateEachWordSpace': 'Please separate each word with a space.',
  'unlock.mnemonic.warning.desc1': 'This option restores a lost keystore file or password,',
  'unlock.mnemonic.warning.desc2': 'or imports a seed from another wallet app.',
  'unlock.mnemonic.warning.desc3':
    'Warning! Entering your seed phrase or private key on any website is very dangerous. If you have malicious extensions installed in your browser or accidentally visit a phishing website, your assets can be stolen.',
  'unlock.privateKey.enterYourPrivateKey': 'Enter your private key (hex format)',
  'unlock.privateKey.invalid':
    'The Private Key you entered is not in the right format and is invalid. Please try again.',
  'unlock.privateKey.passwordInvalid': 'That password is invalid. Please try again.',
  'unlock.privateKey.warning': 'For restoring a lost keystore file or password',
  'unlock.privateKey.warningQuestion':
    'Entering your private key on any website is very dangerous. If you have malicious extensions installed in your browser or accidentally visit a phishing website, your assets can be stolen.',
  'unlock.recover.content':
    'Recover wallet access using a recovery phrase made known during wallet creation',
  'unlock.recover.download.button': 'Download',
  'unlock.recover.downloadTitle': 'Download Your Keystore File',
  'unlock.recover.password.placeholder': 'Enter a strong password',
  'unlock.recover.submit': 'Submit',
  'unlock.recover.title': 'Recover a Keystore File',
  'unlock.recover.understand.continue': 'Recover a Keystore File',
  'unlock.recover.word.placeholder': 'Search',
  'unlock.recover.wordlist.reset': 'Reset',
  'unlock.recover.wordlistTitle': 'Please select your Mnemonic Phrase from the left list',
  'unlock.support.wallets': ' ',
  'unlock.temporarySessionPassword': 'Temporary session password',
  'unlock.thisIsNotAValidWalletFile': 'This is not a valid wallet file',
  'unlock.trezor.connectToTrezor': 'Connect to Trezor',
  'unlock.trezor.firmwareNotice':
    'Note: Please make sure that you have updated to the latest Trezor firmware in order to use your device with the Binance Chain.',
  'unlock.trezor.notOnTestNet': 'Note: Trezor devices require Chrome or Firefox for now ',
  'unlock.trezor.title': 'Unlock with a Trezor Device',
  'unlock.unlockWalletNow': 'Unlock Wallet Now',
  'unlock.walletConnect.notes':
    'Note: Trust Wallet and CoolWallet do not support the Binance Chain Testnet.',
  'unlock.walletConnect.recommendedWallet': 'Supported apps include',
  'unlock.walletConnet.getTrustWallet': 'Get Trust Wallet',
  'unlock.walletConnet.qrCodeDesc1': 'Get WalletConnect QR Code',
  'unlock.walletConnet.qrCodeDesc2': 'Don’t have an app that supports WalletConnect yet?',
  'unlock.walletConnet.showWalletQrCode':
    'Connect your mobile wallet here using a QR code on this screen',
  'unlock.walletConnet.title': 'Recommended',
  'walletConnect.clickHereToUnlock': 'Click here to unlock another wallet',
  'walletConnect.error': 'WalletConnect Error',
  'walletConnect.errorOccur': 'A WalletConnect error has occurred',
  'walletConnect.pleaseEnsureOpenWorking': 'Please ensure that the app is open and working.',
  'walletConnect.pleaseUseAWalletConnect':
    'Please use an app that supports WalletConnect to scan the QR code above',
  'walletConnect.qrCode': 'WalletConnect QR code',
  'walletConnect.readyToConfirm': 'Please Confirm',
  'walletConnect.readyToConfirmBody': 'Please confirm the transaction on the wallet App.',
  'walletconnect.notifycation.connectAgain': 'Connect again',
  'walletconnect.notifycation.disconnectMessage': ' Disconnected from Mobile Wallet...',
  'walletconnect.notifycation.hide': 'Hide',
  'local.secure.storage': 'Local Secure Storage',
  'local.keystore.replace.tips':
    'You already have a keystore file, make sure you have backed up before replace',
}
